<template>
  <div class="verification-container">
    <div class="verification-title-container">
      <!--账号数据校验结果-->
      <div class="title-text">{{ $t('userManage.AccountDataVerificationResult') }}</div>
      <!--系统已完成 Excel 数据解析，并对人员身份、重复账号、岗位、账号时效等规则进行校验。-->
      <div style="font-size: 14px">{{ $t('userManage.TheSystemHasCompletedParsingExcelData') }}</div>
    </div>
    <div style="padding: 20px">
      <el-row :gutter="20" style="margin-bottom: 20px;">
        <el-col :span="8">
          <div class="import-total">
            <!--导入总数-->
            <div style="font-size: 12px">{{ $t('userManage.TotalImports') }}</div>
            <div style="font-size: 18px;font-weight: bold;color:#000;">{{ validateData.totalCount }}</div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="import-total">
            <!--校验通过-->
            <div style="font-size: 12px">{{ $t('userManage.VerificationPassed') }}</div>
            <div style="font-size: 18px;font-weight: bold;color:#0ca040;">{{ validateData.validCount }}</div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="import-total">
            <!--校验失败-->
            <div style="font-size: 12px">{{ $t('userManage.VerificationFailed') }}</div>
            <div style="font-size: 18px;font-weight: bold;color:#dc2626;">{{ validateData.invalidCount }}</div>
          </div>
        </el-col>
      </el-row>
      <div class="result-container">
        <!--校验结果-->
        <span style="font-weight: bold;margin-right: 5px;">{{ $t('userManage.VerificationResult') }}:</span>
        <!--共有 5 条数据未通过校验。你可以下载错误明细后修改 Excel 并重新上传，也可以仅继续创建已通过校验的 121 个账号。-->
        <span>{{ $t('userManage.ATotalOf') }} {{ validateData.invalidCount }} {{ $t('userManage.items') }} {{
          $t('userManage.dataHaveFailedVerification')
        }} {{ validateData.validCount }} {{ $t('userManage.accountsThatHavePassedVerification') }}</span>
      </div>
      <!--校验未通过数据-->
      <div class="failed-title">{{ $t('userManage.DataThatFailedVerification') }}（{{ validateData.invalidCount }}）</div>
      <div style="display:flex;">
        <div style="flex: 1">
          <el-form size="small">
            <el-row>
              <el-col :span="20">
                <el-form-item>
                  <el-input v-model="searchParam" :placeholder="$t('collectionCenter.compellation') + '/CPF'" clearable />
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item>
                  <el-button size="small" @click="searchInvalidData">{{ $t('basicData.Search') }}</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div style="flex: 1;text-align: right">
          <!--下载错误明细-->
          <el-button icon="el-icon-bottom" size="small" @click="downloadErr">{{ $t('userManage.DownloadErrorDetails') }}</el-button>
        </div>
      </div>

      <el-table :data="tableData" border max-height="300">
        <!--Excel 行号-->
        <el-table-column :label="$t('userManage.lineNumber')" prop="rowNumber" />
        <!--姓名-->
        <el-table-column :label="$t('collectionCenter.compellation')" prop="realName" />
        <el-table-column label="CPF" prop="cpf">
          <template slot-scope="scope">
            <div>{{ formatCpfCnpj(scope.row.cpf) }}</div>
          </template>
        </el-table-column>
        <!--所属转运中心-->
        <el-table-column :label="$t('collectionCenter.owningTransitCenter1')" prop="hubName" />
        <!--岗位-->
        <el-table-column :label="$t('home.position')" prop="positionName" />
        <!--账号有效天数-->
        <el-table-column :label="$t('userManage.NumberOfDaysTheAccountIsValid')" prop="validDays" />
        <!--校验状态-->
        <el-table-column :label="$t('basicData.VerificationStatus')" prop="valid">
          <template slot-scope="scope">
            <el-tag v-if="!scope.row.valid" type="danger" size="mini">{{ $t('basicData.failed') }}</el-tag>
            <el-tag v-if="scope.row.valid" type="success" size="mini">{{ $t('basicData.success') }}</el-tag>
          </template>
        </el-table-column>
        <!--校验结果-->
        <el-table-column :label="$t('userManage.VerificationResult')" prop="errorMessage">
          <template slot-scope="scope">
            <div style="color:#cb272d;">{{ scope.row.errorMessage }}</div>
          </template>
        </el-table-column>
      </el-table>
      <div style="display: flex;margin-bottom: 20px;">
        <div style="font-size: 14px">{{ $t('userManage.ATotalOf') }} {{ validateData.invalidCount }} {{ $t('userManage.items') }}{{ $t('userManage.DataThatFailedVerification') }}</div>
      </div>
      <div class="confirm-sub">
        <el-form ref="submitParamRef" :model="submitParam" size="small">
          <el-form-item
            prop="checked"
            :rules="{
              required: true,
              message: $t('userManage.PleaseCheckTheConfirmationBoxBeforeContinuingToCreateCnAccount'),
              trigger: 'change'
            }"
          >
            <el-checkbox-group v-model="submitParam.checked">
              <!--我已确认本次将仅创建校验通过的 121 个账号，校验失败的 5 条数据不会创建。-->
              <el-checkbox label="1">
                {{ $t('userManage.IHaveConfirmedThatOnlyThe') }}
                {{ validateData.validCount }}
                {{ $t('userManage.accountsThatHavePassedVerificationWill') }}
                {{ validateData.invalidCount }}
                {{ $t('userManage.piecesOfDataThatFailed') }}
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="re-upload-container">
      <div style="flex: 1;font-size: 14px">
        <!--重新上传 Excel-->
        <el-button @click="reUploadExcel">{{ $t('userManage.ReUploadExcel') }}</el-button>
      </div>
      <div style="flex: 1;text-align: right;">
        <!--下载错误明细-->
        <el-button icon="el-icon-bottom" @click="downloadErr">{{ $t('userManage.DownloadErrorDetails') }}</el-button>
        <!--创建100个账号-->
        <el-button type="primary" @click="uploadVerification">{{ $t('userManage.Create') + validateData.validCount + $t('userManage.accounts') }}</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { formatCpfCnpj } from '@/views/user/temporaryWorkerAccount/utils';
import { getFreelancerImportConfirmApi, getFreelancerImportErrorsApi } from '@/api/user';

export default {
  name: 'Verification',
  props: {
    validateData: {
      type: Object,
      default: () => {
        return {
          invalidCount: 0,
          totalCount: 0,
          validCount: 0,
          originalFilename: '',
          importToken: '',
          rows: []
        };
      }
    }
  },
  data() {
    return {
      searchParam: '',
      tableData: [],
      submitParam: {
        checked: []
      },
      invalidData: []
    };
  },
  created() {
    this.$nextTick(() => {
      this.getFailureData();
    });
  },
  methods: {
    // 搜索
    searchInvalidData() {
      const query = this.searchParam.trim().toLowerCase();
      if (query) {
        this.tableData = this.invalidData.filter(item => {
          // 兼容用户输入带格式的 CPF (如 123.456.789-00)，先去除特殊符号
          const cleanFm = formatCpfCnpj(item.cpf).toLowerCase();
          const cleanCpf = item.cpf.toLowerCase();
          const cleanName = item.realName;
          // 模糊匹配：CPF 包含 或者 姓名包含
          return cleanCpf.includes(query) || cleanFm.includes(query) || cleanName.includes(query);
        });
      } else {
        this.tableData = this.invalidData;
      }
    },
    // 格式化cpf
    formatCpfCnpj,
    // 获取校验失败数据
    getFailureData() {
      if (this.validateData.rows.length > 0) {
        this.tableData = [];
        this.invalidData = [];
        this.validateData.rows.map(item => {
          if (!item.valid) {
            this.tableData.push(item);
            this.invalidData.push(item);
          }
        });
      }
    },
    // 下载失败明细
    async downloadErr() {
      const data = await getFreelancerImportErrorsApi(this.validateData.importToken);
      const blob = new Blob([data.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = '临时工账号校验失败明细.xlsx';

      // 触发下载
      document.body.appendChild(link);
      link.click();

      // 清理
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    },
    // 上传
    uploadVerification() {
      this.$refs.submitParamRef.validate(valid => {
        if (valid) {
          const param = {
            importToken: this.validateData.importToken
          };
          getFreelancerImportConfirmApi(param).then(res => {
            if (res.code === 200) {
              this.$emit('createAccounts', 3, res.data);
            }
          });
        }
      });
    },
    // 重新上传
    reUploadExcel() {
      this.$emit('submitUploadFile', 1);
    }
  }
};
</script>
<style scoped>
.verification-container {
  background:#fff;
  border-radius: 10px;
  border: 1px solid #ddd;
}
.verification-title-container {
  border-bottom: 1px solid #ccc;
  padding: 15px 20px;
}
.title-text {
  font-size: 17px;
  font-weight: bold;
  color:#000;
}
.import-total {
  border-radius: 10px;
  border: 1px solid #ddd;
  padding: 20px;
}
.result-container {
  border: 1px solid #f3debb;
  border-radius: 10px;
  padding: 10px;
  font-size: 14px;
  background:#fff8ee;
  margin-bottom: 20px;
  color: #7b5d2c;
}
.failed-title {
  font-weight: bold;
  font-size: 14px;
  margin-bottom: 10px;
}
.confirm-sub {
  border: 1px solid #ddd;
  background:#fcfdfd;
  border-radius: 10px;
  padding: 10px;
}
.re-upload-container {
  display: flex;
  align-items: center;
  padding: 20px;
  border-top: 1px solid #ddd;
}
</style>
